import { render, staticRenderFns } from "./CanvasTreeNode.template.vue?vue&type=template&id=357ec3a2&scoped=true&"
var script = {}
import style0 from "./CanvasTreeNode.template.vue?vue&type=style&index=0&id=357ec3a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ec3a2",
  null
  
)

export default component.exports